import { WA_PLACEHOLDERS } from "../lib/waTemplates";

// Etichette cliccabili dei segnaposto WhatsApp: al click inseriscono il segnaposto nel punto del cursore.
export default function WaPlaceholderChips({ onInsert, testId = "wa-ph" }) {
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {WA_PLACEHOLDERS.map((p) => (
        <button key={p} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onInsert(p)}
          data-testid={`${testId}-${p.replace(/[[\]]/g, "").replace(/\s+/g, "-")}`}
          className="rounded-full border border-[#25D366]/50 bg-[#25D366]/10 px-2 py-0.5 text-[11px] font-medium text-[#128C7E] transition-colors hover:bg-[#25D366]/20">
          {p}
        </button>
      ))}
    </div>
  );
}
